/**
 * @generated SignedSource<<996766e5e19cbb12b1844932d1c75651>>
 * @relayHash 8b68080551a7f9d8c683e2cdad0f3c6b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 229ffbee9e88534afad73dcd45015d5915f0b70eccfc27936ad7ce53e311963f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PopupContentQuery } from './PopupContentQuery.graphql';

const node: PreloadableConcreteRequest<PopupContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "229ffbee9e88534afad73dcd45015d5915f0b70eccfc27936ad7ce53e311963f",
    "metadata": {},
    "name": "PopupContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
